import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const MIN_SPOTS = 3;
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > MIN_SPOTS ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const claimed = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  return <div className="mt-6 rounded-2xl border border-wine/20 bg-wine-soft p-4" data-id="element-57" data-mp="2b933zhbdlhaj">
      <div className="flex items-center justify-between gap-3" data-id="element-58" data-mp="2g74pe8w9xsp6">
        <p className="flex items-center gap-1.5 text-sm font-extrabold text-wine sm:text-base" data-id="element-59" data-mp="2273ncq49wf84">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-60" data-mp="274dc03ju8muw" />
          Only {spotsLeft} spots left at $27
        </p>
        <span className="text-sm font-bold tabular-nums text-navy" data-id="element-61" data-mp="f8e0h5homt2">{Math.round(claimed)}% claimed</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-wine/15" role="progressbar" aria-valuenow={Math.round(claimed)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-62" data-mp="5bpdu8m1wplz">
        <div className="h-full rounded-full bg-wine transition-[width] duration-300 ease-out" style={{
        width: `${claimed}%`
      }} data-id="element-63" data-mp="3dc6alqyspnm8" />
      </div>
      <p className="mt-2 text-xs font-medium text-muted" data-id="element-64" data-mp="2kn8yy6p3ap2g">
        When the remaining spots are taken, the price returns to its regular value.
      </p>
    </div>;
}